<div class="flex w-fit items-center rounded-14px border border-solid border-stroke">
    @for (item of buttonItems(); let i = $index; track item.title) {
        <button
            [class]="
                [
                    'flex py-3 px-25px justify-center items-center gap-2.5 rounded-14px mob:px-3.5',
                    activeButtonIndex() === i
                        ? 'text-white text-medium-medium bg-dark border-dark border border-solid'
                        : 'text-dark-4 text-medium-medium bg-white',
                ] | joinClassNames
            "
            (click)="toggle(item.title, i)"
        >
            {{ item.title }}
            @if (item.specialOffer) {
                <span class="text-dark-5"> {{ item.specialOffer }}</span>
            }
        </button>
    }
</div>
